import { Link } from "react-router-dom";

const HeroBtn = ({ title, underline, css, to }) => {
  return (
    <div className={`${css || ""} relative group`}>
      <Link
        to={to}
        className="block text-white font-semibold px-1.5 text-[11px] sm:text-[14px] hover:text-white/90 transition-a"
      >
        {title}
      </Link>
      <div
        className={`absolute h-[2.5px] bottom-0 left-0 group-hover:bg-[#FFFFFF] ${underline || ""} w-full duration-200 ease-out`}
      />
    </div>
  );
};

export default HeroBtn;
